//#region src/components/ActionCard/types/ActionCardTone.ts
var e = /* @__PURE__ */ function(e) {
	return e.Opportunity = "opportunity", e.Decision = "decision", e.Waiting = "waiting", e.Blocker = "blocker", e;
}({});
//#endregion
export { e as ActionCardTone };
